'use client';

import { useField } from 'formik';
import { Input, type CommonInputProps } from 'src/shared/ui/Input';

import styles from '../index.module.css';

type FieldInputProps = Omit<CommonInputProps, 'name'> & {
  name: string;
};

export const FieldInput = ({ name, onChange, ...props }: FieldInputProps) => {
  const [field, meta] = useField<string | null>(name);

  return (
    <Input
      {...props}
      {...field}
      inputClassName={styles.fieldInput}
      fieldClassName={styles.controllerInput}
      value={field.value ?? ''}
      onChange={field.onChange}
      onBlur={field.onBlur}
      error={meta.touched && meta.error ? meta.error : undefined}
    />
  );
};
